// extracted by mini-css-extract-plugin
export var childrenContainer = "_ax-0";